import React from 'react';

import Tab from '../components/Tab';
import Dropdown from '../components/Dropdown';
import BudgetInput from './Inputs/BudgetInput';

const Budget = () => {
  return(
    <div className='vesta-dropdown-filter-container'>
      <Tab name='Budget' tab='budget' />

      <Dropdown title='Quel budget avez-vous ?' tab='budget'>
        <div className='vesta-w-full'>
          <BudgetInput />
        </div>
      </Dropdown>
    </div>
  )
};

export default Budget;
